import React, { useEffect, useCallback } from 'react';

import Modal from '../UI/Modal';
import Well from '../UI/Well';
import FormGroup from '../UI/FormGroup/FormGroup';
import SubGroup from '../UI/FormGroup/SubGroup';
import ErrorHint from '../UI/ErrorHint';

import { URL } from '../../constants';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../actions'


const RequestForm = props => {
    const { register, handleSubmit, errors } = useForm();
    const captchaImage = useSelector(state => state.auth.captchaImage);
    const dispatch = useDispatch();

    const fetchCaptcha = useCallback(() => dispatch(actions.fetchCaptcha()), [dispatch]);

    const onSubmit = async (data) => {
        const response = await fetch(`${URL}/auth/${props.id}`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
            body: JSON.stringify(data)
        })
        .then(res => res.json())
        .then(resJson => {
            if (resJson.isSuccess) {
                alert(resJson.message);
                window.location.reload();
            } else {
                if (resJson.message !== '驗證碼錯誤') {
                    alert('帳號或Email輸入錯誤');
                } else {
                    alert(resJson.message);
                }
                fetchCaptcha();
            }
        });
    }

    useEffect(() => {
        fetchCaptcha();

        const interval = setInterval(() => {
            fetchCaptcha();
        }, 60 * 1000);

        return () => clearInterval(interval);
    }, [fetchCaptcha]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Modal title={props.title} id={props.id}>
                <Well>
                    <fieldset>
                        <FormGroup>
                            <SubGroup label={props.inputLabels[0]} labelWidth='3' fieldWidth='9'>
                                <input
                                    type='text'
                                    className='form-control'
                                    maxLength='50'
                                    name={props.fieldNames[0]}
                                    autoComplete='off'
                                    ref={register({ required: '此欄不可空白' })}
                                />
                                <ErrorHint errors={errors} name={props.fieldNames[0]} />
                            </SubGroup>
                        </FormGroup>

                        <FormGroup>
                            <SubGroup label={props.inputLabels[1]} labelWidth='3' fieldWidth='9'>
                                <input
                                    type='text'
                                    className='form-control'
                                    maxLength='50'
                                    name={props.fieldNames[1]}
                                    autoComplete='off'
                                    ref={register({ required: '此欄不可空白' })}
                                />
                                <ErrorHint errors={errors} name={props.fieldNames[1]} />
                            </SubGroup>
                        </FormGroup>

                        <FormGroup>
                            <SubGroup label={props.inputLabels[2]} labelWidth='3' fieldWidth='9'>
                                <input
                                    type='text'
                                    className='form-control'
                                    maxLength='5'
                                    name={props.fieldNames[2]}
                                    autoComplete='off'
                                    ref={register({ required: '此欄不可空白' })}
                                />
                                <ErrorHint errors={errors} name={props.fieldNames[2]} />
                            </SubGroup>
                        </FormGroup>

                        <FormGroup>
                            <SubGroup fieldWidth='12'>
                                <div style={{ textAlign: 'right' }}>
                                    {captchaImage && <img src={captchaImage} alt='驗證碼' style={{border: '1px solid #cccccc'}}/>}
                                    <button
                                        type='button'
                                        className='rnBt_icon'
                                        style={{ border: 'none', outline: 'none', marginLeft: '16px' }}
                                        onClick={fetchCaptcha}
                                    >
                                        <img src='../images/rn.png' alt='重置驗證碼' />
                                    </button>
                                </div>
                            </SubGroup>
                        </FormGroup>

                        <FormGroup>
                            <SubGroup fieldWidth='12'>
                                <div className='btn-box'>
                                    <button className='btn btn-success'>送 出</button>
                                </div>
                            </SubGroup>
                        </FormGroup>
                    </fieldset>
                </Well>
            </Modal>
        </form>
    );
}

export default RequestForm;